import type { FC, ReactNode } from 'react'
import type { Schematic } from '@/types'

import { cn } from '@/lib/utils'
import SchematicFigure from '@/components/content/schematic-figure'

interface ArchitectureBlockProps {
    schematic: Schematic
    id: string
    figure?: string
    title?: string
    className?: string
}

/** Architecture plate followed by a parts list, the way a spec document would present it. */
const ArchitectureBlock: FC<ArchitectureBlockProps> = ({ schematic, id, figure = '01', title = 'Architecture', className }): ReactNode => {
    return (
        <section aria-label={title} className={cn('flex flex-col gap-6', className)}>
            <SchematicFigure schematic={schematic} id={id} figure={figure} title={title} />

            <div>
                <p className='font-mono text-label uppercase text-muted-foreground'>Parts</p>

                <ul className='mt-3 grid grid-cols-1 border-t border-border sm:grid-cols-2 sm:gap-x-8'>
                    {schematic.nodes.map((node) => (
                        <li key={node.id} className='flex items-baseline justify-between gap-4 border-b border-border py-2.5'>
                            <span className={cn('font-mono text-[0.8125rem]', node.kind === 'accent' ? 'text-brand' : 'text-foreground')}>
                                {node.label}
                            </span>
                            {node.sub && (
                                <span className='text-right text-[0.8125rem] text-muted-foreground'>{node.sub}</span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default ArchitectureBlock
